import { Button, useFormContext } from "@4uhub/lib4uhub";
import { useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { TUnchosenProfessionalPriorityForm } from "../unchosenProfessionalPrioritySchema";
import { Grid, Typography } from "@mui/material";
import { UnchosenProfessionalThenRow } from "./UnchosenProfessionalThenRow";
import AddIcon from "@mui/icons-material/Add";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutRecRuleUnchosenProfessionalRule.";

export const UnchosenProfessionalThen = () => {
  const { t } = useTranslation();

  const { control, formState } =
    useFormContext<TUnchosenProfessionalPriorityForm>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "thenPriorities",
  });

  const offersErrorMessage = !!formState.errors.thenPriorities;

  const handleAddContact = () => {
    append({});
  };

  return (
    <Grid
      container
      spacing={4}
      sx={(t) => ({
        mt: 5,
        pr: 3,
        pl: 1,
        py: 3,
        border: `1px solid ${
          offersErrorMessage ? t.palette.error.main : t.palette.divider
        }`,
        borderRadius: 2,
      })}
    >
      <Grid item sm={12}>
        <Typography fontWeight="bold">{t(translationPath + "then")}</Typography>
      </Grid>

      {fields.map((item, index) => (
        <UnchosenProfessionalThenRow
          key={item.id}
          index={index}
          remove={remove}
        />
      ))}

      <Grid item sm={12}>
        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={handleAddContact}
        >
          {t(translationPath + "add_priority") || "Add Priority"}
        </Button>
      </Grid>
    </Grid>
  );
};
